import { HTTPError as _KyHTTPError } from "ky"
import type { KyRequest, KyResponse, NormalizedOptions, Options as _KyOptions } from "ky"

import { ParsedQuery } from "@finq/app-base/lib/queryParams"

export interface KyOptions<KyParams = ParsedQuery> extends Omit<_KyOptions, "searchParams"> {
  params?: KyParams
  responseType?: "blob" | "json" | "none"
}

export interface ApiError {
  code: number
  date: string
  timestamp: number
  description: string
  guid: string
}

export class KyHTTPError extends _KyHTTPError {
  data?: ApiError
  constructor(response: KyResponse, request: KyRequest, options: NormalizedOptions, data?: ApiError) {
    super(response, request, options)
    this.data = data
  }
}

export interface PaginationResponse<T> {
  data: T[]
  paging: any
  groups?: any
  additional?: any
}

export interface ApiServiceConfig extends _KyOptions {
  baseUrl?: string

  /**
   * Called when the request is unauthorized.
   * If the function returns true, the request will be retried.
   */
  onUnauthorized?: (req: KyRequest) => boolean
}
